import { cloneDeep } from "lodash";

export const filters = {
  state: {
    stash: {},
    filters: {
      shift_assign_process: null,
      date_range: null,
      min_rate: null,
      max_rate: null,
      shift_start_date: null,
      shift_end_date: null,
      pharmacy_name: null,
      distance: null,
      created_at_from: null,
      created_at_to: null,
      // type: 0,
      days: {
        monday: {
          active: true,
          value: 1,
        },
        tuesday: {
          active: true,
          value: 2,
        },
        wednesday: {
          active: true,
          value: 3,
        },
        thursday: {
          active: true,
          value: 4,
        },
        friday: {
          active: true,
          value: 5,
        },
        saturday: {
          active: true,
          value: 6,
        },
        sunday: {
          active: true,
          value: 7,
        },
      },
      travel: {
        paying_for_travel: {
          active: false,
          label: 'Pays for Travel',
          description: null,
        }
      },
      additional: {
        open_up: {
          active: false,
          label: "Open Up",
          description: null,
        },
        close: {
          active: false,
          label: "Close",
          description: null,
        },
        solo_shift: {
          active: false,
          label: "Solo shift",
          description: null,
        },
        opioid_rehab: {
          active: false,
          label: "Opioid Rehabilitation",
          description: null,
        },
      },
       state: {}
    },
    oldfilter: {
      
    },
    open: false,
  },
  getters: {
    getFilters: (state) => state.filters,
    getOldFilters: (state) => state.oldfilter,
    isFilterOpen: (state) => state.open,
  },
  actions: {
    cloneFilters(store) {
      store.commit("CLONE_INIT_FILTERS");
    },
    restoreFilters(store) {
      store.commit("RESTORE_INIT_FILTERS");
    },
    updateFilters(store, data) {
      store.commit("UPDATE_FILTERS", data);
    },
    setOldFilters(store, data) {
      store.commit("SET_OLD_FILTER_VALUE", data)
    },
    restoreOldFilters(store) {
      store.commit("RESTORE_OLD_FILTERS");
    },
    toggleFilters(store) {
        store.commit("TOGGLE_FILTERS");
    }
  },
  mutations: {
    UPDATE_FILTERS(state, data) {
      state.filters = data;
    },
    CLONE_INIT_FILTERS: (state) => {
      state.stash = cloneDeep(state.filters);
    },
    RESTORE_INIT_FILTERS: (state) => {
      state.filters = cloneDeep(state.stash);
    },
    
    SET_OLD_FILTER_VALUE(state, data) {
      state.oldfilter =  data;
    },
    RESTORE_OLD_FILTERS(state) {
      state.oldfilter =  cloneDeep(state.stash);
    },
    TOGGLE_FILTERS(state) {
        state.open = !state.open;
    }
  },
};
